/* eslint-disable @typescript-eslint/quotes */
import { Component, NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

import { AuditTrailComponent } from "./audit-trail/audit-trail.component";
import { CategoryComponent } from "./chatbot/category/category.component";
import { ChatbotHistoryComponent } from "./chatbot/chatbot-history/chatbot-history.component";
import { ChatbotComponent } from "./chatbot/chatbot.component";
import { QuestionAnswerKeywordComponent } from "./chatbot/question-answer-keyword/question-answer-keyword.component";
import { SubCategoryComponent } from "./chatbot/sub-category/sub-category.component";
import { CreateGrievanceComponent } from "./grievance/internal-user/create-grievance/create-grievance.component";
import { MyGrievanceComponent } from "./grievance/internal-user/my-grievance/my-grievance.component";
import { ViewGrievanceComponent } from "./grievance/internal-user/view-grievance/view-grievance.component";
import { AssginedGrievanceViewReplyComponent } from "./grievance/support-user/assign-grievances/assgined-grievance-view-reply/assgined-grievance-view-reply.component";
import { AssignedGrievanceViewComponent } from "./grievance/support-user/assign-grievances/assigned-grievance-view/assigned-grievance-view.component";
import { AssignedObjectionSuggestionListComponent } from "./grievance/support-user/assigned-objections-and-suggestions/assigned-objection-suggestion-list/assigned-objection-suggestion-list.component";
import { AddGrievanceTypeComponent } from "./grievance/support-user/crud/grievance-type/add-grievance-type/add-grievance-type.component";
import { ListGrievanceTypeComponent } from "./grievance/support-user/crud/grievance-type/list-grievance-type/list-grievance-type.component";
import { UpdateGrievanceTypeComponent } from "./grievance/support-user/crud/grievance-type/update-grievance-type/update-grievance-type.component";
import { AddObjectionSuggestionComponent } from "./grievance/support-user/crud/objection-suggestion-type/add-objection-suggestion/add-objection-suggestion.component";
import { ListObjectionSuggestionComponent } from "./grievance/support-user/crud/objection-suggestion-type/list-objection-suggestion/list-objection-suggestion.component";
import { UpdateObjectionSuggestionComponent } from "./grievance/support-user/crud/objection-suggestion-type/update-objection-suggestion/update-objection-suggestion.component";
import { RegSupportUserrComponent } from "./grievance/support-user/raise-grievance/reg-support-userr/reg-support-user.component";
import { SupportCreateGrievanceListComponent } from "./grievance/support-user/raise-grievance/support-create-grievance-list/support-create-grievance-list.component";
import { SuppportUserAssignedGrievanceComponent } from "./grievance/support-user/assign-grievances/suppport-user-assigned-grievance/support-user-assigned-grievance.component";
import { ViewAssignedObjectionSuggestionListComponent } from "./grievance/support-user/assigned-objections-and-suggestions/view-assigned-objection-suggestion-list/view-assigned-objection-suggestion-list.component";
import { LoginComponent } from "./login/login.component";
import { HomeComponent } from "./secure/home/home.component";
import { NewDashboardComponent } from "./secure/new-dashboard/new-dashboard.component";
import { NewDashboardLotteryWiseComponent } from "./secure/new-dashboard-lotterywise/new-dashboard-lotterywise.component";
import { NewDashboardSchemeWiseComponent } from "./secure/new-dashboard-schemewise/new-dashboard-schemewise.component";
import { ModerationAuditTrailListComponent } from "./secure/moderation-audit-trail-list/moderation-audit-trail-list.component";
import { ModerationListComponent } from "./secure/moderation-list/moderation-list.component";
import { ModerationComponent } from "./secure/moderation/moderation.component";
import { ReportsComponent } from "./secure/reports/reports.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { ReportComponent } from "./grievance/support-user/grievance-report/report.component";
import { ObjectionSuggestionReportComponent } from "./grievance/support-user/objection-suggestion-report/objection-suggestion-report.component";
import { MasterGrievanceListComponent } from "./grievance/support-user/master-grievance-list/master-grievance-list.component";

import { UserListComponent } from "./secure/master/user/list/user-list.component";
import { UserAUComponent } from "./secure/master/user/au/user-au.component";
import { RoleListComponent } from "./secure/master/role/list/role-list.component";
import { RoleAUComponent } from "./secure/master/role/au/role-au.component";
import { PaymentReconciliationComponent } from "./secure/payment-reconciliation/payment-reconciliation.component";
import { BoardAUComponent } from "./secure/master/board/au/board-au.component";
import { BoardListComponent } from "./secure/master/board/list/board-list.component";
import { OrganizationAUComponent } from "./secure/master/organization/au/organization-au.component";
import { OrganizationListComponent } from "./secure/master/organization/list/organization-list.component";
import { FeatureListComponent } from "./secure/master/feature/list/feature-list.component";
import { FeatureAUComponent } from "./secure/master/feature/au/feature-au.component";
import { ImportMasterComponent } from "./secure/import-master/import-master.component";
import { CallCenterSearchComponent } from "./secure/call-center/search/call-center-search.component";
import { CallCenterViewComponent } from "./secure/call-center/search/view/call-center-view.component";
import { SchemeListComponent } from "./secure/master/scheme/list/scheme-list.component";
import { SchemeAUComponent } from "./secure/master/scheme/au/scheme-au.component";
import { MasterGrievanceViewComponent } from "./grievance/support-user/master-grievance-view/master-grievance-view.component";
import { LotteryListComponent } from "./secure/master/lottery/list/lottery-list.component";
import { LotteryAuComponent } from "./secure/master/lottery/au/lottery-au.component";
import { RegistrationComponent } from "./audit-trail/registration/registration.component";
import { ApplicationComponent } from "./audit-trail/application/application.component";
import { PaymentComponent } from "./audit-trail/payment/payment.component";
import { AddEscalationDurationComponent } from "./grievance/support-user/crud/escalation-duration/add-escalation-duration/add-escalation-duration.component";
import { ListEscalationDurationComponent } from "./grievance/support-user/crud/escalation-duration/list-escalation-duration/list-escalation-duration.component";
import { UpdateEscalationDurationComponent } from "./grievance/support-user/crud/escalation-duration/update-escalation-duration/update-escalation-duration.component";
import { BankMasterListComponent } from "./secure/bank-master/list/bank-master-list.component";
import { BankMasterAUComponent } from "./secure/bank-master/au/bank-master-au.component";
import { CheckDocumentImageComponent } from "./audit-trail/check-document-image/check-document-image.component";
import { ProfileDetailsComponent } from "./audit-trail/profile-details/profile-details.component";
import { PaymentPendingTransactionsComponent } from "./secure/payment-pending-transactions/payment-pending-transactions.component";
import { NocDashboardComponent } from "./secure/noc-dashboard/noc-dashboard.component";
import { GenerateSummaryReportComponent } from "./audit-trail/generate-summary-report/generate-summary-report.component";
import { UserChatsComponent } from "./audit-trail/user-chats/user-chats.component";
// import { LotteryAuComponent } from "./secure/master/lottery/au/lottery-au.component";
// import { LotteryListComponent } from "./secure/master/lottery/list/lottery-list.component";

import { ChangePasswordComponent } from "./secure/change-password/change-password.component";
import { AllocateGroupComponent } from "./secure/allocate-group/allocate-group.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { ReactiveFormsModule } from "@angular/forms";
import { ExportAppsComponent } from "./secure/export-apps/export-apps.component";
import { ExportPhotosComponent } from "./secure/export-photos/export-photos.component";
import { ExportPolComponent } from "./secure/export-pol/export-pol.component";
import { GetAllAssetsComponent } from "./audit-trail/blockchain/get-all-assets/get-all-assets.component";
import { CreateAssetComponent } from "./audit-trail/blockchain/create-asset/create-asset.component";
import { GetAssetByIdComponent } from "./audit-trail/blockchain/get-asset-by-id/get-asset-by-id.component";
import { ImportResultsComponent } from "./secure/import-results/import-results.component";
import { AnnouncementListComponent } from "./secure/announcement/list/announcement-list.component";
import { AnnouncementAuComponent } from "./secure/announcement/au/announcement-au.component";
import { ApplicationListComponent } from "./secure/document-verification/list/application-list.component";
import { ActiveWaitlistComponent } from "./secure/active-reverse-waitlist/active-waitlist/active-waitlist.component";
import { ShiftTenementsComponent } from "./secure/shift-tenements/shift-tenements.component";
import { SopManagementListComponent } from "./secure/sop-management/list/sop-management-list.component";
import { SopManagementAuComponent } from "./secure/sop-management/au/sop-management-au.component";
import { ViewApplicationComponent } from "./secure/view-application/view-application.component";
import { ViewApplicationDtlComponent } from "./secure/view-application/view/view-application-dtl.component";
import { ProApproverListComponent } from "./secure/pro-approver-list/pro-approver-list.component";
import { ProApproverComponent } from "./secure/pro-approver/pro-approver.component";
import { VerifyEsignComponent } from "./secure/verify-esign/verify-esign.component";
import { QueryExecutorListComponent } from "./secure/query-executor-list/query-executor-list.component";
import { QueryExecutorComponent } from "./secure/query-executor/query-executor.component";
import { InstallmentConfigComponent } from "./secure/installment-config/installment-config.component";
import { NocApproverListComponent } from "./secure/noc-approver-list/noc-approver-list.component";
import { NocApproverComponent } from "./secure/noc-approver/noc-approver.component";
import { EmailSmsComponent } from "./secure/email-sms-notification/email-sms.component";
import { SopMasterAuComponent } from "./secure/sop-master/au/sop-master.component";
import { SopMasterListComponent } from "./secure/sop-master/list/sopMaster-list.component";
import { CorrigendumApplicationComponent } from "./secure/corrigendum-upload/table/corrigendum-table.component";
import { CorrigendumApplicationFormComponent } from "./secure/corrigendum-upload/form/corrigendum-form.component";
import { ModalComponent } from "./secure/corrigendum-upload/modal/modal.component";
import { EmailDashboardComponent } from "./secure/email-dashboard/email-dashboard.component";
import { PaymentSettlementComponent } from "./secure/payment-settlement/payment-settlement.component";
import { DocumentVerificationComponent } from "./secure/document-verificationAllotment/document-verification.component";
import { ClerkDocumentVerificationComponent } from "./secure/document-verificationClerk/clerkdocument-verification.component";
import { POLDocumentVerificationComponent } from "./secure/document-verificationPol/poldocument-verification.component";
import { ViewDocumentDtlComponent } from "./secure/document-verificationAllotment/view/view-document-dtl.component";
import { ViewPolDocumentDtlComponent } from "./secure/document-verificationPol/view/view-poldocument-dtl.component";
import { EngineeringDocumentVerificationComponent } from "./secure/document-verificationEnginering/engineringdocument-verification.component";
import { ApplicantAuditTrailComponent } from "./secure/applicant-auditTrail/applicantAudit-trail.component";
import { ViewEngineeringDocumentDtlComponent } from "./secure/document-verificationEnginering/view/view-enginerdocument-dtl.component";
import { ViewClerkDocumentDtlComponent } from "./secure/document-verificationClerk/view/view-clerk-document-dtl.component";
import { ViewAuditTrailDocumentDtlComponent } from "./secure/applicant-auditTrail/view/view-auditTrail-document-dtl.component";
import { ViewPaymentDtlComponent } from "./secure/payment-settlement/view/view-payment-dtl.component";
import { ProcessRefundComponent } from "./secure/process-refund/process-refund.component";
import { SignOffReportListComponent } from "./secure/signoff-report/list/signoff-report-list.component";
import { SignOffReportAUComponent } from "./secure/signoff-report/au/signoff-report-au.component";
import { AllotmentLetterGeneratation } from "./secure/allotment-letter-generatation/allotment-letter-generatation.component";
import { PublishLettersComponent } from "./secure/publish-letters/publish-letters.component";
import { nocPendingDashboardComponent } from "./secure/nocPendingDashboard/nocPendingDashboard.component";
import { ImportBulkPolComponent } from "./secure/import-bulkPol/import-bulkPol.component";
import { DashboardListComponent } from "./secure/dashboard/dashboard-list.component";
import { DashBoardViewApplicationDtlComponent } from "./secure/dashboard/view/dashboard-view-app-dtl.component";
import { CasteValRefLetterApproverListComponent } from "./secure/caste-val-ref-letter-approver-list/caste-val-ref-letter-approver-list.component";
import { CasteValRefLetterApproverComponent } from "./secure/caste-val-ref-letter-approver/caste-val-ref-letter-approver.component";
import { ViewAppealHearingDtlComponent } from "./secure/applicant-hearing/view/appeal-hearing-dtl.component";
import { AppealHearingComponent } from "./secure/applicant-hearing/appeal-hearing.component";
import { ApplicantApproverListComponent } from "./secure/applicant-editing-approver-list/applicant-approver-list.component";
import { ApplicantApproverDtlComponent } from "./secure/applicant-editing-approver-list/applicant-approver-dtl/applicant-approver-dtl.component";
import { PhotoUploadComponent } from "./secure/applicant-editing-approver-list/applicant-approver-dtl/photo-upload/photo-upload.component";
import { BoardDocumentsListComponent } from "./secure/board-documents-list/board-documents-list.component";
import { BoardDocumentComponent } from "./secure/board-document/board-document.component";
import { LettersListComponent } from "./secure/letters-generate-list/letters-generate-list.component";
import { AgreementIndxUpldComponent } from "./secure/agreement-indx-upld/agreement-indx-upld.component";
import { AgreementIndxUpldDtlComponent } from "./secure/agreement-indx-upld/view/agreement-indx-upld-dtl.component";
import { TenementExchangeListComponent } from "./secure/tenement-exchange/list/tenement-exchange-list.component";
import { TenementExchangeFormComponent } from "./secure/tenement-exchange/form/tenement-exchange-form.component";
import { DownloadCastvalidityZipComponent } from "./secure/download-castvalidityzip/download-castvalidityzip.component";
import { DashboardDataentryListComponent } from "./secure/dashboard-dataentry-list/dashboard-dataentry-list.component";
import { DashboardDataEntryComponent } from "./secure/dashboard-dataentry/dashboard-dataentry.component";
import { NewLotteryListComponent } from "./secure/master/new-lottery/new-list/new-lottery-list.component";
import { NewLotteryAuComponent } from "./secure/master/new-lottery/new-au/new-lottery-au.component";
import { NewLotteryComponent } from "./secure/master/new-lottery/new-lottery.component";
import { BlockchainVerifyListComponent } from "./secure/blockchain-verify-list/blockchain-verify-list.component";
import { CasteValVerificationListComponent } from "./secure/caste-val-verification/list/caste-val-verification-list.component";
import { CasteValViewApplicationComponent } from "./secure/caste-val-verification/view/caste-val-verification-view.component";
import { UpdatePossessionDtlListComponent } from "./secure/update-possession-dtl-list/update-possession-dtl-list.component";
import { UpdatePossessionDtlComponent } from "./secure/update-possession-dtl/update-possession-dtl.component";
import { ProfileResetComponent } from "./secure/profile-reset/profile-reset.component";
import { PaymentDashboardComponent } from "./secure/payment-dashboard/payment-dashboard.component";
import { ViewApplicationDocumentsComponent } from "./secure/view-application-documents/view-application-documents.component";
import { ViewApplicationDocumentDtlComponent } from "./secure/view-application-documents/view/view-application-document-dtl.component";
import { PaymentExtensionListComponent } from "./secure/payment-extension/payment-extension-list.component";
import { PaymentExtensionDtlComponent } from "./secure/payment-extension/view/payment-extension-dtl.component";
import { SMSNotificationLotteryResultListComponent } from "./secure/sms-notif-lot-result-list/sms-notif-lot-result-list.component";
import { ApplicantCountReport } from "./secure/application-count-report/application-count-report.component";
import { UpdateSpousePanDetails } from "./secure/update-spouse-pan-details/update-spouse-pan.component";
import { ApplicationDocumentView } from "./secure/applicant-document-view/applicant-document-view.component";
import { BlockchainDashboardComponent } from "./secure/blockchain-dashboard/blockchain-dashboard.component";
import { ChangeEligibilityComponent } from "./secure/change-eligibility/change-eligibility.component";
import { RevertChangeEligibilityComponent } from "./secure/revert-change-eligibility/revert-change-eligibility.component";
import { PanAdharUpdateDetails } from "./secure/pan-adhar-home/pan-adhar-home.component";
import { UpdateAadharDetails } from "./secure/pan-adhar-home/update-adhar/update-adhar.component";
import { EBillingReportComponent } from "./secure/report_e_billing/report_e_billing.component";
import { UploadTenementMasterComponent } from "./secure/engineer-tenement-upload/form/upload-tenement-master.component";
import { AppealButtonShowComponent } from "./secure/change-eligibility/appeal-button-show/appeal-button-show.component";
import { SpouseAadharChange } from "./secure/pan-adhar-home/change-spouse-aadhar/change-spouse-aadhar.component";
import { DownloadProjectTenementComponent } from "./secure/download-project-tenement/download-project-tenement.component";
import { PaymentDefaulterListComponent } from "./secure/payment-defaulter-list/payment-defaulter-list.component";
import { UpdateApplicantMobileNoAndEmailId } from "./secure/pan-adhar-home/update-applicant-mob-email/update-applicant-mob-email.component";
import { UpdateSpouseEmailId } from "./secure/pan-adhar-home/update-spouse-email/update-spouse-email.component";
import { SurrReqVerificationComponent } from "./secure/surr-req-verification/surr-req-verification.component";
import { ViewSurrReqDtlComponent } from "./secure/surr-req-verification/view/view-surr-req-dtl.component";
import { PaymentRefundComponent } from "./secure/payment-refund/payment-refund.component";
import { UploadTenementMasterList } from "./secure/engineer-tenement-upload/list/upload-tenement-list.component";
import { UploadCorriegendumComponent } from "./secure/upload-corriegendum/upload-corriegendum.component";
import { ViewPaymentRefundDtlComponent } from "./secure/payment-refund/view/view-payment-refund-dtl.component";
import { ProjectListComponent } from "./secure/project/list/project-list.component";
import { ProjectAUComponent } from "./secure/project/au/project-au.component";
import { AmenityListComponent } from "./secure/amenity/list/amenity-list.component";
import { AmenityAUComponent } from "./secure/amenity/au/amenity-au.component";

import { InvoiceTrackingComponent } from "./secure/invoice-tracking/invoice-tracking.component";
import { InvoiceTrackingFormComponent } from "./secure/invoice-tracking/form/invoice-tracking-form.component";
import { GeneratedInvoiceFormComponenet } from "./secure/invoice-tracking/generated-invoice/generated-invoice-list.component";
import { GeneratedInvoiceView } from "./secure/invoice-tracking/generated-invoice-view/generated-invoice-view.component";
import { PaymentRefundUploadComponent } from "./secure/payment-refund-upload/payment-refund-upload.component";
import { DownloadApplicantPanAdharPolZipComponent } from "./secure/download-applicant-pan-adhar-pol-zip/download-applicant-pan-adhar-pol-zip.component";

import { InstallmentConfigModalComponent } from "./secure/installment-config/installment-config-modal/installment-config-modal.component";
import { ExtendedAcceptanceComponent } from "./secure/extend-acceptance/extend-acceptance.component";
import { NewPaymentExtensionListComponent } from "./secure/new-payment-extension/new-payment-extension-list.component";
import { AdvAdvertisementListComponent } from "./secure/adv-advertisement-list/adv-advertisement-list.component";
import { MomMeetingModule } from "./secure/mom-meeting/mom-meeting/mom-meeting.module";
import { MomStartMeetingComponent } from "./secure/mom-meeting/mom-start-meeting/mom-start-meeting.component";
import { MomApproveMeetingComponent } from "./secure/mom-meeting/mom-approve-meeting/mom-approve-meeting.component";
import { TenementInstallmentConfigComponent } from "./secure/tenement-installment-config/tenement-installment-config.component";
import { PendencyDashboarComponent } from "./secure/Pendency-Dashboard/pendency-dashboard.component";
import { AddNomineeOfApplicationComponent } from "./secure/add-nominee/add-nominee.component";
import { AddNomineeFormComponent } from "./secure/add-nominee/add-nominee-form/add-nominee-form.component";
import { RevertActivatedWaitlistComponent } from "./secure/revert-activated-waitlist/revert-activated-waitlist.component";
import { ChnageRejectedApplicantAadharDetails } from "./secure/pan-adhar-home/change-rejected-applicant-adhar/change-rejected-applicant-adhar.component";
import { SchemeEditorComponent } from "./secure/scheme-editor/scheme-editor.component";
import { ExtendedSurrenderComponent } from "./secure/extend-surrender/extend-surrender.component";
import { FinancialYearListComponent } from "./secure/financial-year/list/financial-year-list.component";
import { FinancialYearAUComponent } from "./secure/financial-year/au/financial-year-au.component";
import { ProfileDetailsNewComponent } from "./audit-trail/profile-details-new/profile-details-new.component";
import { ICTDashboardComponent } from "./secure/ict-dashboard/ict-dashboard.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  {
    path: "secure",
    component: SidenavComponent,
    children: [
      {
        path: "audit-trail",
        component: AuditTrailComponent,
        children: [
          { path: "", component: RegistrationComponent },
          { path: "application", component: ApplicationComponent },
          { path: "payment", component: PaymentComponent },
          {
            path: "checkDocumentImage",
            component: CheckDocumentImageComponent,
          },
          { path: "profileDetails", component: ProfileDetailsNewComponent },
          {
            path: "generateSummaryReport",
            component: GenerateSummaryReportComponent,
          },
          { path: "user-chats", component: UserChatsComponent },
        ],
      },
      {
        path: "blockchain",
        children: [
          { path: "get-all-assets", component: GetAllAssetsComponent },
          { path: "create-asset", component: CreateAssetComponent },
          { path: "get-asset-by-id", component: GetAssetByIdComponent },
        ],
      },

      {
        path: "chatbot",
        component: ChatbotComponent,
        children: [
          { path: "", component: ChatbotHistoryComponent },
          { path: "category", component: CategoryComponent },
          { path: "sub-category", component: SubCategoryComponent },
          {
            path: "question-answer-keyword",
            component: QuestionAnswerKeywordComponent,
          },
        ],
      },

      { path: "view-grievance", component: ViewGrievanceComponent },
      { path: "invoice", component: InvoiceTrackingComponent },
      {
        path: "invoice-tracking/form",
        component: InvoiceTrackingFormComponent,
      },
      {
        path: "invoice-tracking/generated-invoice",
        component: GeneratedInvoiceFormComponenet,
      },
      {
        path: "invoice-tracking/generated-invoice-view/:invoiceNo",
        component: GeneratedInvoiceView,
      },
      { path: "allocate-group", component: AllocateGroupComponent },
      { path: "my-grievances", component: MyGrievanceComponent },
      { path: "create-grievance", component: CreateGrievanceComponent },
      { path: "view-grievance/:myid", component: ViewGrievanceComponent },

      {
        path: "caste-val-application",
        component: CasteValVerificationListComponent,
      },
      {
        path: "caste-val-view-application/:applicationId",
        component: CasteValViewApplicationComponent,
      },

      {
        path: "reg-create-support-user/:myid",
        component: RegSupportUserrComponent,
      },
      {
        path: "assigned-grievances",
        component: SuppportUserAssignedGrievanceComponent,
      },
      {
        path: "master-grievance-view/:myid",
        component: MasterGrievanceViewComponent,
      },
      {
        path: "assigned-grievance-view/:myid",
        component: AssignedGrievanceViewComponent,
      },
      {
        path: "search-user-list",
        component: SupportCreateGrievanceListComponent,
      },
      {
        path: "assgined-grievance-view-reply/:myid",
        component: AssginedGrievanceViewReplyComponent,
      },

      {
        path: "assigned-objection-suggestion-list",
        component: AssignedObjectionSuggestionListComponent,
      },

      {
        path: "view-assigned-objection-suggestion/:myid",
        component: ViewAssignedObjectionSuggestionListComponent,
      },
      { path: "add-grievance-type", component: AddGrievanceTypeComponent },
      { path: "grievance-type-list", component: ListGrievanceTypeComponent },
      {
        path: "update-grievance-type/:myid",
        component: UpdateGrievanceTypeComponent,
      },

      {
        path: "add-objection-suggestion-type",
        component: AddObjectionSuggestionComponent,
      },

      {
        path: "update-objection-suggestion-list/:myid",
        component: UpdateObjectionSuggestionComponent,
      },
      {
        path: "objection-suggestion-type-list",
        component: ListObjectionSuggestionComponent,
      },
      { path: "grievance-report", component: ReportComponent },
      {
        path: "objection-and-suggestion-report",
        component: ObjectionSuggestionReportComponent,
      },

      {
        path: "master-grievance-list",
        component: MasterGrievanceListComponent,
      },
      {
        path: "add-escalation-duration/:myid",
        component: AddEscalationDurationComponent,
      },
      {
        path: "list-escalation-duration/:myid",
        component: ListEscalationDurationComponent,
      },
      {
        path: "update-escalation-duration/:myid",
        component: UpdateEscalationDurationComponent,
      },

      { path: "announcement/list", component: AnnouncementListComponent },
      { path: "announcement/au", component: AnnouncementAuComponent },
      { path: "announcement/au/:key", component: AnnouncementAuComponent },
      { path: "verify-blockchain", component: BlockchainVerifyListComponent },
      {
        path: "verify-blockchain/:blockchainTransactionType",
        component: BlockchainVerifyListComponent,
      },
      {
        path: "verify-blockchain/:blockchainTransactionType/:boardId",
        component: BlockchainVerifyListComponent,
      },
      {
        path: "verify-blockchain/:blockchainTransactionType/:boardId/:lotteryId",
        component: BlockchainVerifyListComponent,
      },
      {
        path: "verify-blockchain/:blockchainTransactionType/:boardId/:lotteryId/:schemeId",
        component: BlockchainVerifyListComponent,
      },
      { path: "blockchain-dashboard", component: BlockchainDashboardComponent },
      {
        path: "possession-dtl-update/list",
        component: UpdatePossessionDtlListComponent,
      },
      {
        path: "possession-dtl-update/:applicationId",
        component: UpdatePossessionDtlComponent,
      },
      {
        path: "sms-notif-lot-result",
        component: SMSNotificationLotteryResultListComponent,
      },

      {
        path: "document-verification/list",
        component: ApplicationListComponent,
      },
      { path: "active-waitlist", component: ActiveWaitlistComponent },

      { path: "sop-master/au", component: SopMasterAuComponent },
      { path: "sop-master/au/:key", component: SopMasterAuComponent },
      { path: "sop-master/list", component: SopMasterListComponent },
      {
        path: "corrigendum-upload/table",
        component: CorrigendumApplicationComponent,
      },
      {
        path: "corrigendum-upload/form/:applicationId",
        component: CorrigendumApplicationFormComponent,
      },
      {
        path: "corrigendum-upload/modal/:key",
        component: ModalComponent,
      },
      { path: "home", component: HomeComponent },
      { path: "new-dashboard", component: NewDashboardComponent },
      { path: "application-list", component: DashboardListComponent },

      { path: "pendency-dashboard", component: PendencyDashboarComponent },

      {
        path: "new-dashboard-lotterydtl/:lotteryKey",
        component: NewDashboardLotteryWiseComponent,
      },
      {
        path: "new-dashboard-schemedtl/:schemeKey",
        component: NewDashboardSchemeWiseComponent,
      },
      {
        path: "dashboard-view-application/:applicationId",
        component: DashBoardViewApplicationDtlComponent,
      },
      {
        path: "signoff-report",
        children: [
          { path: "list", component: SignOffReportListComponent },
          { path: "au", component: SignOffReportAUComponent },
        ],
      },
      {
        path: "master",
        children: [
          { path: "user/list", component: UserListComponent },
          { path: "user/au", component: UserAUComponent },
          { path: "user/au/:key", component: UserAUComponent },
          { path: "role/list", component: RoleListComponent },
          { path: "role/au", component: RoleAUComponent },
          { path: "role/au/:key", component: RoleAUComponent },
          { path: "feature/list", component: FeatureListComponent },
          { path: "feature/au", component: FeatureAUComponent },
          { path: "feature/au/:key", component: FeatureAUComponent },
          { path: "organization/list", component: OrganizationListComponent },
          { path: "organization/au", component: OrganizationAUComponent },
          { path: "organization/au/:key", component: OrganizationAUComponent },

          { path: "board/list", component: BoardListComponent },
          { path: "board/au", component: BoardAUComponent },
          { path: "board/au/:key", component: BoardAUComponent },

          { path: "scheme/list", component: SchemeListComponent },
          { path: "scheme/au", component: SchemeAUComponent },
          { path: "scheme/au/:key", component: SchemeAUComponent },

          { path: "lottery/list", component: LotteryListComponent },
          { path: "lottery/au", component: LotteryAuComponent },
          { path: "lottery/au/:key", component: LotteryAuComponent },

          { path: "new-lottery/list", component: NewLotteryListComponent },
          { path: "new-lottery/au", component: NewLotteryAuComponent },
          { path: "new-lottery/au/:key", component: NewLotteryAuComponent },
          { path: "new-lottery", component: NewLotteryComponent },
        ],
      },
      { path: "project/list", component: ProjectListComponent },
      { path: "project/au", component: ProjectAUComponent },
      { path: "project/au/:key", component: ProjectAUComponent },
      { path: "amenity/list", component: AmenityListComponent },
      { path: "amenity/au", component: AmenityAUComponent },
      { path: "amenity/au/:key", component: AmenityAUComponent },
      { path: "financial-year/list", component: FinancialYearListComponent },
      { path: "financial-year/au", component: FinancialYearAUComponent },
      { path: "financial-year/au/:key", component: FinancialYearAUComponent },
      {
        path: "adv-advertisement-list",
        component: AdvAdvertisementListComponent,
      },
      {
        path: "adv-advertisement",
        loadChildren: () =>
          import("./secure/adv-advertisement/adv-advertisement.module").then(
            (m) => m.AdvertisementModule
          ),
      },
      {
        path: "mom-meeting-type",
        loadChildren: () =>
          import("./secure/mom-meeting-type/mom-meeting-type.module").then(
            (m) => m.MomMeetingTypeModule
          ),
      },
      // MomMeetingTypeModule,   data: { breadcrumb: '' } },
      {
        path: "mom-meeting",
        loadChildren: () => MomMeetingModule,
        data: { breadcrumb: "" },
      },
      {
        path: "mom-start-meeting",
        component: MomStartMeetingComponent,
        data: { breadcrumb: "Start Meeting" },
      },
      {
        path: "mom-approve-meeting",
        component: MomApproveMeetingComponent,
        data: { breadcrumb: "Approve Meeting" },
      },
      {
        path: "dashboard-dataentry-list",
        component: DashboardDataentryListComponent,
      },
      { path: "moderation-list", component: ModerationListComponent },
      { path: "query-executor-list", component: QueryExecutorListComponent },
      { path: "board-documents-list", component: BoardDocumentsListComponent },
      { path: "pro-approver-list", component: ProApproverListComponent },
      {
        path: "caste-val-ref-letter-approver-list",
        component: CasteValRefLetterApproverListComponent,
      },
      { path: "view-application", component: ViewApplicationComponent },
      { path: "agreement-indx-upld", component: AgreementIndxUpldComponent },
      {
        path: "view-application/:applicationId",
        component: ViewApplicationDtlComponent,
      },
      {
        path: "view-application/:applicationId/:pageMode",
        component: ViewApplicationDtlComponent,
      },
      {
        path: "agreement-indx-upld/:applicationId",
        component: AgreementIndxUpldDtlComponent,
      },
      {
        path: "agreement-indx-upld/:applicationId/:pageMode",
        component: AgreementIndxUpldDtlComponent,
      },
      {
        path: "agreement-indx-upld/:applicationId/:pageMode",
        component: AgreementIndxUpldDtlComponent,
      },
      { path: "reports", component: ReportsComponent },
      {
        path: "moderation/:registrationModerationKey",
        component: ModerationComponent,
      },
      { path: "dashboard-dataentry", component: DashboardDataEntryComponent },
      {
        path: "dashboard-dataentry/:key",
        component: DashboardDataEntryComponent,
      },

      { path: "query-executor", component: QueryExecutorComponent },
      { path: "query-executor/:key", component: QueryExecutorComponent },
      { path: "board-documents", component: BoardDocumentComponent },
      { path: "board-documents/:key", component: BoardDocumentComponent },
      {
        path: "pro-approver-dtl/:certJournalistKey",
        component: ProApproverComponent,
      },
      {
        path: "caste-val-ref-letter-approver-dtl/:key",
        component: CasteValRefLetterApproverComponent,
      },
      {
        path: "moderation-audit-trail",
        component: ModerationAuditTrailListComponent,
      },
      {
        path: "payment-reconciliation",
        component: PaymentReconciliationComponent,
      },
      { path: "import/master", component: ImportMasterComponent },
      { path: "call-center", component: CallCenterSearchComponent },
      {
        path: "call-center/:registrationId",
        component: CallCenterViewComponent,
      },
      {
        path: "call-center/:registrationId/:applicationId",
        component: CallCenterViewComponent,
      },
      { path: "export-apps", component: ExportAppsComponent },
      { path: "export-photos", component: ExportPhotosComponent },
      { path: "export-pol", component: ExportPolComponent },
      {
        path: "download-castvalidityzip",
        component: DownloadCastvalidityZipComponent,
      },
      {
        path: "download-docs",
        component: DownloadApplicantPanAdharPolZipComponent,
      },
      { path: "profile-reset", component: ProfileResetComponent },
      { path: "import-results", component: ImportResultsComponent },
      { path: "shift-tenements", component: ShiftTenementsComponent },
      { path: "sop-management/list", component: SopManagementListComponent },
      { path: "sop-management/au", component: SopManagementAuComponent },
      {
        path: "verify-esign/:esignType/:esignKey",
        component: VerifyEsignComponent,
      },
      { path: "installment-config", component: InstallmentConfigComponent },

      { path: "bank-master/list", component: BankMasterListComponent },
      { path: "bank-master/au", component: BankMasterAUComponent },
      { path: "bank-master/au/:key", component: BankMasterAUComponent },
      {
        path: "payment-pending-transactions",
        component: PaymentPendingTransactionsComponent,
      },
      { path: "noc-dashboard", component: NocDashboardComponent },
      { path: "change-password", component: ChangePasswordComponent },
      { path: "noc-approver-list", component: NocApproverListComponent },
      { path: "noc-approver-dtl/:mortKey", component: NocApproverComponent },
      { path: "email-sms-notification", component: EmailSmsComponent },
      { path: "email-dashboard", component: EmailDashboardComponent },
      {
        path: "payment-refund-upload",
        component: PaymentRefundUploadComponent,
      },
      { path: "payment-settlement", component: PaymentSettlementComponent },
      { path: "appeal-hearing", component: AppealHearingComponent },
      { path: "change-eligibility", component: ChangeEligibilityComponent },
      {
        path: "payment-defaulter-list",
        component: PaymentDefaulterListComponent,
      },
      {
        path: "change-eligibility/appeal-button-show",
        component: AppealButtonShowComponent,
      },
      {
        path: "revert-change-eligibility",
        component: RevertChangeEligibilityComponent,
      },
      {
        path: "document-verificationAllotment",
        component: DocumentVerificationComponent,
      },

      { path: "payment-extension", component: PaymentExtensionListComponent },
      {
        path: "payment-extension-dtl/:applicationNo",
        component: PaymentExtensionDtlComponent,
      },

      {
        path: "document-verificationPol",
        component: POLDocumentVerificationComponent,
      },
      {
        path: "document-verificationEnginering",
        component: EngineeringDocumentVerificationComponent,
      },
      {
        path: "applicant-auditTrail",
        component: ApplicantAuditTrailComponent,
      },
      {
        path: "document-verificationClerk",
        component: ClerkDocumentVerificationComponent,
      },

      {
        path: "payment-settlement/:applicationNo/:this.filterForm.value.paymentStatus",
        component: ViewPaymentDtlComponent,
      },
      {
        path: "document-verificationAllotment/:applicationNo",
        component: ViewDocumentDtlComponent,
      },

      {
        path: "document-verificationAllotment/:applicationNo/:source",
        component: ViewDocumentDtlComponent,
      },
      {
        path: "document-verificationPol/:applicationNo",
        component: ViewPolDocumentDtlComponent,
      },
      {
        path: "document-verificationEnginering/:applicationNo",
        component: ViewEngineeringDocumentDtlComponent,
      },
      {
        path: "document-verificationEnginering/:applicationNo/:source",
        component: ViewEngineeringDocumentDtlComponent,
      },
      {
        path: "document-verificationClerk/:applicationNo",
        component: ViewClerkDocumentDtlComponent,
      },
      {
        path: "document-verificationClerk/:applicationNo/:source",
        component: ViewClerkDocumentDtlComponent,
      },

      {
        path: "document-verificationAudit/:applicationNo",
        component: ViewAuditTrailDocumentDtlComponent,
      },
      {
        path: "document-verificationAudit/:applicationNo/:source",
        component: ViewAuditTrailDocumentDtlComponent,
      },

      {
        path: "document-verificationPol/:applicationNo/:source",
        component: ViewPolDocumentDtlComponent,
      },
      {
        path: "payment-settlement/:applicationNo/:source/:paymentStatus",
        component: ViewPaymentDtlComponent,
      },
      { path: "payment-dashboard", component: PaymentDashboardComponent },

      {
        path: "appeal-hearing-dtl/:applicationNo/:appealType",
        component: ViewAppealHearingDtlComponent,
      },
      { path: "process-refund", component: ProcessRefundComponent },
      { path: "publish-letters", component: PublishLettersComponent },
      { path: "import-bulkPol", component: ImportBulkPolComponent },
      { path: "nocPendingDashboard", component: nocPendingDashboardComponent },
      { path: "letters", component: LettersListComponent },
      {
        path: "allotment-letter-generation-dtl/:applicationNo",
        component: AllotmentLetterGeneratation,
      },
      {
        path: "allotment-letter-generation-dtl/:applicationNo/fetch",
        component: AllotmentLetterGeneratation,
      },
      {
        path: "applicant-editing-approver-list",
        component: ApplicantApproverListComponent,
      },
      {
        path: "applicant-approver-dtl/:key/:applicationNo/:type/:status",
        component: ApplicantApproverDtlComponent,
      },
      {
        path: "applicant-approver-dtl/:key/:applicationNo/:type/:status/:oldMaritalStatus",
        component: ApplicantApproverDtlComponent,
      },
      {
        path: "tenement-exchange/list",
        component: TenementExchangeListComponent,
      },
      {
        path: "tenement-exchange/form/:applicationKey/:schemeId/:lotteryId",
        component: TenementExchangeFormComponent,
      },

      {
        path: "view-application-documents",
        component: ViewApplicationDocumentsComponent,
      },
      {
        path: "view-application-documents-dlt",
        component: ViewApplicationDocumentDtlComponent,
      },

      {
        path: "view-application-documents/:applicationId",
        component: ViewApplicationDocumentDtlComponent,
      },
      {
        path: "view-application-documents/:applicationId/:pageMode",
        component: ViewApplicationDocumentDtlComponent,
      },

      {
        path: "application-count-report",
        component: ApplicantCountReport,
      },
      //  { path: "update-spouse-pan", component: UpdateSpousePanDetails },
      {
        path: "applicant-document-view/:applicationId/:cancelType",
        component: ApplicationDocumentView,
      },
      {
        path: "pan-aadhar-update-home-page/update-spouse-pan",
        component: UpdateSpousePanDetails,
      },
      { path: "pan-aadhar-update-home-page", component: PanAdharUpdateDetails },
      {
        path: "pan-aadhar-update-home-page/aadhar-update-page",
        component: UpdateAadharDetails,
      },
      {
        path: "pan-aadhar-update-home-page/applicant-aadhar-change",
        component: SpouseAadharChange,
      },
      { path: "project-tenement", component: DownloadProjectTenementComponent },
      { path: "e-billing-report", component: EBillingReportComponent },
      { path: "upload-corriegendum", component: UploadCorriegendumComponent },
      { path: "payment-refund", component: PaymentRefundComponent },
      {
        path: "payment-refund/:applicationNo/:this.filterForm.value.paymentStatus",
        component: ViewPaymentRefundDtlComponent,
      },
      {
        path: "payment-refund/:applicationNo/:source/:paymentStatus",
        component: ViewPaymentRefundDtlComponent,
      },

      {
        path: "engineer-tenement-upload",
        component: UploadTenementMasterList,
      },
      {
        path: "engineer-tenement-upload/list",
        component: UploadTenementMasterList,
      },
      {
        path: "engineer-tenement-upload/form",
        component: UploadTenementMasterComponent,
      },

      {
        path: "pan-aadhar-update-home-page/applicant-mobileno-emailid",
        component: UpdateApplicantMobileNoAndEmailId,
      },

      {
        path: "pan-aadhar-update-home-page/spouse-emailid",
        component: UpdateSpouseEmailId,
      },
      {
        path: "surr-req-verification",
        component: SurrReqVerificationComponent,
      },
      {
        path: "surr-req-verification-dtl/:applicationNo/:key/:source",
        component: ViewSurrReqDtlComponent,
      },
      {
        path: "extend-acceptance",
        component: ExtendedAcceptanceComponent,
      },
      {
        path: "new-payment-extension",
        component: NewPaymentExtensionListComponent,
      },
      {
        path: "payment-extension-dtl/:applicationNo",
        component: PaymentExtensionDtlComponent,
      },
      {
        path: "tenement-installment-config",
        component: TenementInstallmentConfigComponent,
      },
      {
        path: "add-nominee",
        component: AddNomineeOfApplicationComponent,
      },
      {
        path: "add-nominee-form/:applicationId",
        component: AddNomineeFormComponent,
      },
      {
        path: "revert-activated-waitlist",
        component: RevertActivatedWaitlistComponent,
      },
      {
        path: 'pan-aadhar-update-home-page/aadhar-update-page/change-rejected-app-adhar',
        component: ChnageRejectedApplicantAadharDetails
      },
      {
        path: "scheme-editor",
        component: SchemeEditorComponent,
      },
      {
        path: "extend-surrender",
        component: ExtendedSurrenderComponent,
      },
      {
        path: 'ict-dashboard',
        component: ICTDashboardComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    NgMultiSelectDropDownModule.forRoot(),
    ReactiveFormsModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
